export const getSpecificTargetStyles = () => ({
  tabRoot: {
    marginTop: 4,
    '& button + button': {
      marginLeft: 24,
    },
    '& .message-bar': {
      maxWidth: '540px',
    },
  },
  divider: {
    marginTop: 5,
  },
  tabError: {
    color: '#A80000',
  },
});
